import { render, staticRenderFns } from "./AgentEdit.vue?vue&type=template&id=4b74f8f8&"
import script from "./AgentEdit.vue?vue&type=script&lang=js&"
export * from "./AgentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports